module.exports = require('./components/content');
